export const MaintenanceOverdueTasks = [
  { id: "1", value: "today", label: "Today" },
  { id: "2", value: "yesterday", label: "Yesterday" },
  { id: "3", value: "this-week", label: "This Week" },
  { id: "4", value: "this-month", label: "This Month" },
  { id: "5", value: "last-week", label: "Last Week" },
  { id: "6", value: "last-month", label: "Last Month" },
];

export const CustomerReportDropdownOptions = [
  { id: 1, label: "Excel", value: "excel" },
  { id: 2, label: "PDF", value: "pdf" },
];

export const RevenueReportDropdownOptions = [
  { id: 1, label: "Excel", value: "excel" },
  { id: 2, label: "PDF", value: "pdf" },
];
